import { createSelector } from 'reselect';

export const modalSelector = state => state.modal;

export const modalDataSelector = createSelector(modalSelector, state => state);
